var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1C5.91979 1 1 5.92022 1 12C1 18.0802 5.92022 23 12 23C18.0802 23 23 18.0798 23 12C23 5.91979 18.0798 1 12 1ZM12 21.2812C6.86983 21.2812 2.71875 17.1298 2.71875 12C2.71875 6.86983 6.87018 2.71875 12 2.71875C17.1302 2.71875 21.2812 6.87018 21.2812 12C21.2812 17.1302 17.1298 21.2812 12 21.2812Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.53906C11.5254 6.53906 11.1406 6.9238 11.1406 7.39844V12.9325C11.1406 13.4071 11.5254 13.7919 12 13.7919C12.4746 13.7919 12.8594 13.4071 12.8594 12.9325V7.39844C12.8594 6.9238 12.4746 6.53906 12 6.53906Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.1621C12.6407 17.1621 13.1602 16.6427 13.1602 16.002C13.1602 15.3612 12.6407 14.8418 12 14.8418C11.3593 14.8418 10.8398 15.3612 10.8398 16.002C10.8398 16.6427 11.3593 17.1621 12 17.1621Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.1377a424.svg";
export { ForwardRef as ReactComponent };